import React from 'react';
import { BrowserRouter as Router, Switch, Route, NavLink } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Header } from './components';

import Home from './pages/home';
import Institucional from './pages/institucional';
import Emprestimos from './pages/emprestimos';
import Associese from './pages/associese';
import Noticias from './pages/noticias';
import Contato from './pages/contato';

function App() {
  return (
    <Router>
      <div id="main">
        <Header />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/institucional">
            <Institucional />
          </Route>
          <Route path="/emprestimos">
            <Emprestimos />
          </Route>
          <Route path="/associe-se">
            <Associese />
          </Route>
          <Route path="/noticias">
            <Noticias />
          </Route>
          <Route path="/contato">
            <Contato />
          </Route>
        </Switch>
        <footer id="footer">
          <div className="footer-container">
            <div className="footer-menu">
              <div>
                <h3>
                  <NavLink
                    to="/institucional"
                    exact
                  >
                    Institucional
                  </NavLink>
                </h3>
                <p>
                  <NavLink
                    to="/institucional"
                    exact
                  >
                    A Cooperativa
                  </NavLink>
                </p>
                <p>
                  <NavLink
                    to="/institucional/administracao"
                    exact
                  >
                    Administração
                  </NavLink>
                </p>
                <p>
                  <NavLink
                    to="/institucional/colaboradores"
                    exact
                  >
                    Colaboradores
                  </NavLink>
                </p>
                <p>
                  <NavLink
                    to="/institucional/estatuto"
                    exact
                  >
                    Estatuto
                  </NavLink>
                </p>
                <p>
                  <NavLink
                    to="/institucional/relatorios-legais"
                    exact
                  >
                    Relatórios Legais
                  </NavLink>
                </p>
                <p>
                  <NavLink
                    to="/institucional/indicadores"
                    exact
                  >
                    Indicadores
                  </NavLink>
                </p>
              </div>
              <div>
                <h3>
                  <NavLink
                    to="/emprestimos"
                    exact
                  >
                    Empréstimos
                  </NavLink>
                </h3>
                <p>
                  <NavLink
                    to="/emprestimos"
                    exact
                  >
                    Condições
                  </NavLink>
                </p>
                <p>
                  <NavLink
                    to="/emprestimos/calculadora"
                    exact
                  >
                    Calculadora
                  </NavLink>
                </p>
              </div>
              <div>
                <h3>
                  <NavLink
                    to="/associe-se"
                    exact
                  >
                    Associe-se
                  </NavLink>
                </h3>
              </div>
              <div>
                <h3>
                  <NavLink
                    to="/noticias"
                    exact
                  >
                    Notícias
                  </NavLink>
                </h3>
                <h3>
                  <NavLink
                    to="/contato"
                    exact
                  >
                    Contato
                  </NavLink>
                </h3>
              </div>
              <div className="copyright-div">
                <h4>Cooperativa Cocrafi ©2021</h4>
              </div>
            </div>
            <div className="direitos-reservados">
              <h4>Criado por Torchlight Innovation and Technology</h4>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
